module.exports = __webpack_public_path__ + "static/media/代码包上传演示.d4e9a43a.png";